export default __webpack_public_path__ + "static/media/quality_control_responsive.a98b42da.png";